import type { AppDispatch, RootState } from '../store';
import { refreshAccessToken, setRefreshTimeoutId } from '../store/authSlice';
import { decodeJwt } from './jwt';

/** Обновить accessToken за 2 минуты до exp (минимум через 30 с). */
const REFRESH_SKEW_MS = 120_000;
const MIN_DELAY_MS = 30_000;

/**
 * Планирует тихий refresh accessToken по exp из JWT.
 * Вызывать после login / verify / успешного refresh.
 */
export const scheduleTokenRefresh = () => (dispatch: AppDispatch, getState: () => RootState) => {
  const state = getState().storeAuth;
  const token = localStorage.getItem('accessToken');
  if (!token || !state.isAuthenticated) return;

  const payload = decodeJwt(token);
  if (!payload?.exp) return;

  const expMs = payload.exp * 1000;
  const delay = Math.max(MIN_DELAY_MS, expMs - Date.now() - REFRESH_SKEW_MS);

  if (state.refreshTimeoutId) {
    window.clearTimeout(state.refreshTimeoutId);
  }

  const id = window.setTimeout(() => {
    void dispatch(refreshAccessToken('scheduled'));
  }, delay) as unknown as number;

  dispatch(setRefreshTimeoutId(id));
};

export const clearScheduledTokenRefresh = () => (dispatch: AppDispatch, getState: () => RootState) => {
  const id = getState().storeAuth.refreshTimeoutId;
  if (id) {
    window.clearTimeout(id);
    dispatch(setRefreshTimeoutId(null));
  }
};
